import { render, staticRenderFns } from "./DWPActLicense.vue?vue&type=template&id=1cff0c32&scoped=true&"
import script from "./DWPActLicense.vue?vue&type=script&lang=js&"
export * from "./DWPActLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cff0c32",
  null
  
)

export default component.exports